import iframeResize from 'iframe-resizer/js/iframeResizer';
import Vue from 'vue';

Vue.directive('frame-resize', {
	bind: function(el, { value = {} }) {
		el.addEventListener('load', () => iframeResize(value, el));
	},
	unbind: function(el: any) {
		el.iFrameResizer.removeListeners();
	}
});
